export const replaceUploadPaths = (item, url) => {
  const attachmentRegex = /\(\s*(\/uploads\/[a-f0-9]+\/[^)]+)\)/g;
  return item.replace(attachmentRegex, `(${url}$1)`);
};

export default {
  replaceUploadPaths,
};
